import { render } from "./LessonProductDiscountModal.vue?vue&type=template&id=2da1316d"
import script from "./LessonProductDiscountModal.vue?vue&type=script&lang=js"
export * from "./LessonProductDiscountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__